import { render, staticRenderFns } from "./ListOfProductsWithTag.vue?vue&type=template&id=57c46bb8&scoped=true&"
import script from "./ListOfProductsWithTag.vue?vue&type=script&lang=js&"
export * from "./ListOfProductsWithTag.vue?vue&type=script&lang=js&"
import style0 from "./ListOfProductsWithTag.vue?vue&type=style&index=0&id=57c46bb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c46bb8",
  null
  
)

export default component.exports